import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Participant } from 'twilio-video';

import { telehealthsResources } from '@lib/resources';
import { getInitials } from 'ui-utils';

import useTelehealthSessionContext from '../useTelehealthSessionContext/useTelehealthSessionContext';
import { formatParticipantName, saveTelehealthLog } from '../../utils/helpers';

export default function useParticipantNetworkQualityLevel(participant: Participant) {
  const dispatch = useDispatch();
  const [networkQualityLevel, setNetworkQualityLevel] = useState(participant.networkQualityLevel || 0);
  const { appointmentId, token } = useTelehealthSessionContext();

  useEffect(() => {
    const handleNewtorkQualityLevelChange = (newNetworkQualityLevel: number) => {
      dispatch(
        telehealthsResources.request({
          headers: {
            'x-access-token': token,
          },
          method: 'post',
          url: `/telehealths/session/${appointmentId}/connection-status`,
          data: {
            networkQualityLevel: newNetworkQualityLevel,
          },
          meta: {
            ignoreErrors: true, // this error used to happen when the there is any issue related to connection
          },
        }),
      );

      saveTelehealthLog(
        `Patient/Guest - Network signal changing - ${getInitials(
          formatParticipantName(participant.identity),
        )} - ${newNetworkQualityLevel} of 5`,
      );

      setNetworkQualityLevel(newNetworkQualityLevel || 0);
    };

    setNetworkQualityLevel(participant.networkQualityLevel || 0);
    participant.on('networkQualityLevelChanged', handleNewtorkQualityLevelChange);
    return () => {
      participant.off('networkQualityLevelChanged', handleNewtorkQualityLevelChange);
    };
  }, [dispatch, participant, appointmentId, token]);

  return networkQualityLevel;
}
